/**
 * @description 按钮权限配置
 * @return {Object} 所有页面的按钮信息
 * @return {Array} Object.buttons 页面需要渲染的按钮序号
 * @return {Object} Object.buttonNames 页面需要渲染的按钮序号+名称集合
 */
let buttonInfos = {}
export default function authority() {
  buttonInfos = {}
  let menuList = JSON.parse(localStorage.getItem("menuList"));
  expandMenu(menuList)
  localStorage.setItem('buttonList',JSON.stringify(buttonInfos));
}

function expandMenu(menuList) {
  menuList.forEach(menu => {
    if (menu.menuType == 2) {
      let menuOne = {}
      // 页面需要渲染的按钮序号
      let buttons = []
      // 页面需要渲染的按钮序号+名称集合
      let buttonNames = {}
      
      if (menu.functionButtonCode) {
        buttons = menu.functionButtonCode.split(',')
        if(menu.buttonList && menu.buttonList.length > 0){
          menu.buttonList.forEach(button => {
            
            menu.functionButtonCode.split(',').forEach(url => {
              if (button.buttonUrl === url) {
                buttonNames[url] = button.buttonName
              }
            })
          })
        }
      }
      menuOne[menu.functionUrl] = {
        buttons,
        buttonNames
      }
      buttonInfos = {
        ...buttonInfos,
        ...menuOne
      }
    }
    if (menu.menuList && menu.menuList.length) {
      expandMenu(menu.menuList)
    }

  })
  return buttonInfos
}

